const styles = () => ({
  button: {
    background: "#11497e",
    color: "#FFFF",
    marginTop: 25,
    minWidth: 200,
  },
  backgroundButton: {
    marginTop: 15,
    marginBottom: 15,
    display: "flex",
    justifyContent: "center",
  },
});

export default styles;
